namespace RedBullMOBILE360.SalesApp {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.SalesApp.AddonGrid')
    export class AddonGrid extends Serenity.EntityGrid<AddonRow, any> {
        protected getColumnsKey() { return AddonColumns.columnsKey; }
        protected getDialogType() { return AddonDialog; }
        protected getIdProperty() { return AddonRow.idProperty; }
        protected getInsertPermission() { return AddonRow.insertPermission; }
        protected getLocalTextPrefix() { return AddonRow.localTextPrefix; }
        protected getService() { return AddonService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected override getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                title: 'Export to Excel',
                grid: this,
                service: AddonService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit()
            }));

            return buttons;
        }

    }
}